import htm from "htm";
import { h } from "./core/core";

export const html = htm.bind(h);
export default html;
